import { Skeleton, Stack } from '@mui/material';

interface LoadingStateProps {
  /** Number of skeleton rows to render — match the final content's shape. */
  rows?: number;
  variant?: 'list' | 'card';
}

/**
 * Designed loading state (foundations.md §7.12): skeletons that preserve
 * layout, never a spinner for partial content updates.
 */
export function LoadingState({ rows = 4, variant = 'list' }: LoadingStateProps) {
  if (variant === 'card') {
    return (
      <Stack spacing={2} sx={{ p: 3 }}>
        <Skeleton variant="text" width="40%" height={28} />
        <Skeleton variant="rounded" height={120} />
      </Stack>
    );
  }

  return (
    <Stack spacing={1.5} sx={{ p: 3 }}>
      {Array.from({ length: rows }).map((_, index) => (
        <Skeleton key={index} variant="rounded" height={40} />
      ))}
    </Stack>
  );
}
